<template>
    <div>
        <zm-row>
            <zm-button size="small" @click="fetchData()" class="btn-in-line" plain>refresh</zm-button>
        </zm-row>
        <div class="table-container">
            <zm-table border :data="list"
            v-loading="loading">
                <zm-table-column prop="id" label="id" align="center" width="100px" :show-overflow-tooltip="true">
                </zm-table-column>
                <zm-table-column prop="assignedChannelSet" label="assignedChannelSet" align="center" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <p v-for="item in scope.row.assignedChannelSet" :key="item">{{ item }}</p>
                    </template>
                </zm-table-column>
                <zm-table-column prop="monitorChannelSet" label="monitorChannelSet" align="center" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <p v-for="item in scope.row.monitorChannelSet" :key="item">{{ item }}</p>
                    </template>
                </zm-table-column>
                <zm-table-column prop="subscribeChannelSet" label="subscribeChannelSet" align="center" :show-overflow-tooltip="true" min-width="200px">
                    <template slot-scope="scope">
                        <p v-for="item in scope.row.subscribeChannelSet" :key="item.channelName">
                            {{ item.channelName }} (R:{{ item.reportThreads }},S:{{ item.subscribeThreads }},M:{{ item.metricsThreads }},T:{{ item.currentLoads }})
                        </p>
                    </template>
                </zm-table-column>
                <zm-table-column prop="currentLoads" label="currentLoads" align="center" width="105px">
                </zm-table-column>
                <zm-table-column prop="stage" label="stage" align="center" width="80px" show-overflow-tooltip>
                </zm-table-column>
                <zm-table-column prop="errorMessages" label="errorMessages" align="center" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <p v-for="item in scope.row.errorMessages" :key="item">{{ item }}</p>
                    </template>
                </zm-table-column>
                <zm-table-column prop="lastUpdateTime" label="modifyTime" align="center" width="100px" :formatter="setTime">
                </zm-table-column>
                <!-- <zm-table-column prop="isLeader" label="isLeader" align="center" width="90px">
                    <template slot-scope='scope'>
                        <i class='glyphicon' :class="{'zm-icon-ok':scope.row.isLeader,'zm-icon-close':!scope.row.isLeader}"></i>
                    </template>
                </zm-table-column>
                <zm-table-column prop="generation" label="generation" align="center" width="100px">
                </zm-table-column> -->
            </zm-table>
        </div>
    </div>
</template>
<script>
import { getSentinelSummary } from '../../api/sentinel'
export default {
    name: 'sentinel',
    data () {
        return {
            loading: false,
            list: []
        }
    },
    created () {
        this.fetchData()
    },
    methods: {
        fetchData () {
            this.loading = true
            getSentinelSummary().then(response => {
                this.list = response
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        setTime (row, column, cellValue, index) {
            let time = row[column.property]
            return new Date(parseInt(time)).toLocaleString()
        }
    }
}
</script>
<style>
.btn-in-line{
    margin: 10px;
}
</style>
